"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// checkbox, radio group, switch

const styleOverrides = {
  root: {
    alignItems: 'start',
    '&.Mui-required div': {
      paddingTop: 11
    }
  },
  label: ({
    theme
  }) => ({
    paddingTop: 11,
    color: theme.palette.text.primary
  })
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
